<template>
  <div>
    <div class="gif text-center mt-5">
        <img src="./img/tuercas.gif" alt="">
    </div>
    <div class="text-center mt-3 ml-5 mr-5">
        <h2>Portal en mantenimiento.</h2>
        <h4>Actualmente, el portal se encuentra en mantenimiento temporal para implementar mejoras en el servicio. 
Para continuar tu trámite, te invitamos a realizarlo mediante un folio INNOVA</h4>
        <v-row class="text-center px-4">
             <v-col cols="5"></v-col>
        <v-col cols="2" class="mt-4">
          <v-btn class="btn-azul col-3" block @click="volver"
            >Volver</v-btn
          >
        </v-col>
      </v-row>
         
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    volver(){
        this.$router.push("/pago-en-linea/paso-1");
    }
  }
}
</script>

<style scoped>
    .gif{
        align-content: center;
    }
</style>